/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { LabelComponent } from './label';
export * from './label-adapter';
export * from './label-constants';
export * from './label-core';
export * from './label';
export * from './label-aware';
export function defineLabelComponent() {
    defineCustomElement(LabelComponent);
}
